import { render, staticRenderFns } from "./Leaderboard_Section_Category.vue?vue&type=template&id=061f008e&"
import script from "./Leaderboard_Section_Category.vue?vue&type=script&lang=js&"
export * from "./Leaderboard_Section_Category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports